var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocusedJobApplications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#0d1117"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 32)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 0C21.49 0 0 21.49 0 48c0 21.21 13.75 39.2 32.83 45.55 2.4.44 3.28-1.04 3.28-2.31 0-1.14-.04-4.93-.07-8.94-13.35 2.9-16.17-5.68-16.17-5.68-2.18-5.55-5.33-7.03-5.33-7.03-4.36-2.98.33-2.92.33-2.92 4.82.34 7.36 4.95 7.36 4.95 4.28 7.34 11.23 5.22 13.97 3.99.43-3.1 1.67-5.22 3.05-6.42-10.66-1.21-21.86-5.33-21.86-23.72 0-5.24 1.87-9.52 4.94-12.88-.49-1.21-2.14-6.09.47-12.7 0 0 4.03-1.29 13.2 4.92 3.83-1.06 7.94-1.6 12.02-1.62 4.08.02 8.19.56 12.02 1.62 9.17-6.21 13.19-4.92 13.19-4.92 2.62 6.61.97 11.49.48 12.7 3.07 3.36 4.93 7.64 4.93 12.88 0 18.43-11.22 22.49-21.91 23.68 1.72 1.49 3.26 4.42 3.26 8.9 0 6.43-.06 11.61-.06 13.19 0 1.28.86 2.77 3.3 2.3C82.26 87.19 96 69.21 96 48 96 21.49 74.51 0 48 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusedJobApplications);
export default __webpack_public_path__ + "static/media/FocusedJobApplications.8742c2c8b356d0ef39d1661e65f99c3d.svg";
export { ForwardRef as ReactComponent };